import { render, staticRenderFns } from "./GlobalSettings.vue?vue&type=template&id=c0cbbcdc"
import script from "./GlobalSettings.vue?vue&type=script&lang=js"
export * from "./GlobalSettings.vue?vue&type=script&lang=js"
import style0 from "./GlobalSettings.vue?vue&type=style&index=0&id=c0cbbcdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports